import styled from "styled-components";

export const Wrapper = styled.main`
  margin-top: 50px;
`;

export const WrapperContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 1280px;
  margin: 0 auto;
`;
